//File to generate unique uuid key for reporting usage

import { v5 as uuidv5 } from 'uuid';
import { ColumnValueSegment } from '@opengov/reporting-types';
//See https://github.com/uuidjs/uuid?tab=readme-ov-file#uuidv5name-namespace-buffer-offset
const reportingLibNamespaceUUID = '9d28ab3c-6e95-4fe0-94f1-3a540f89be57';

export const generateUniqueKey = (stringifyInfo: string): string => {
  return uuidv5(stringifyInfo, reportingLibNamespaceUUID);
};

export const generateUniqueRowKey = (groupId: string | undefined, index: number, values: ColumnValueSegment[]) => {
  return generateUniqueKey(JSON.stringify({ groupId, values, index }));
};
